module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAANCAYAAACzbK7QAAAAAXNSR0IArs4c6QAAAOtJREFUOE+t0zErxVEYx/HPU3ar6dZllrKQsliUOyhlsdqs7IxG3oZSymameAMmWa6BDOzkcY/+6nbZzjnT6dT5fs/ze54TKldm7mEQEYP/UFHJl5nbOMNdRCxP8qoFBZiZm7jAdUSsjkuaCDrJFs4nJc0EnWQFN7iKiPVyFpk5hV7ZV/bjC0Ps4xiX2CmCwxH4qBI+fv0d092DT4tgHmsNKiiSFyziAG/YqI3lT+GZeY8ZLETEsJkgM/t47Iy9Av9pcovsM3MOD/hEPyKefrnVgsxcwi0+yjRGxHPTj5aZJ6Px3MVsRLxOJvINHjlF2fgpBzIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/gywm_xl.png
// module id = Y5a+
// module chunks = 1